import { clone, isArray } from 'lodash';

export const processGetFormResponseData = data => {
  const result = {
    options: {
      ...data.options,
    },
  };

  if (data.options?.Date) {
    result.options.date = {
      ...data.options.Date,
      year: Object.values(data.options.Date.year).sort(
        (a, b) => Number(b.value) - Number(a.value)
      ),
    };
  }

  if (data.hasOwnProperty('isRecruiter')) {
    result.isRecruiter = data.isRecruiter;
  }

  result.fields = {
    ...data.fields,
    // roleId: result.options.roleId.find(
    //   role => role.value === data.fields.roleId
    // ),
    // titleId: result.options.titleId.find(
    //   role => role.value === data.fields.titleId
    // ),
    // firmId:
    //   data.fields.firmId && data.fields.firmId.value === -2
    //     ? {
    //         ...data.fields.firmId,
    //         __isNew__: true,
    //       }
    //     : data.fields.firmId,
    // groupId: result.options.groupId.filter(
    //   group => data.fields.groupId.indexOf(group.value) !== -1
    // ).map(group => (group.id ? group : { ...group, id: group.value })),
    // industryId: result.options.industryId.filter(
    //   industry => data.fields.industryId.indexOf(industry.value) !== -1
    // ).map(industry =>
    //   industry.id ? industry : { ...industry, id: industry.value }
    // ),
    startDate:
      data.fields.startMonth && data.fields.startYear
        ? {
            month: data.fields.startMonth,
            year: data.fields.startYear,
          }
        : null,
    endDate:
      data.fields.endMonth && data.fields.endYear
        ? {
            month: data.fields.endMonth,
            year: data.fields.endYear,
          }
        : null,
    // present: Number(data.fields.Present) === 1,
  };

  // result.settings = {
  //   hideIndustry: result.fields.roleId.attrs.HideIndustry,
  //   hasGroups: !!result.fields.roleId.attrs.MainSubgroupTitle,
  //   groupTitle: result.fields.roleId.attrs.OwnGroupsTitle,
  // };

  return result;
};

export const processPostFormRequestData = (data, su = false) => {
  const result = clone(data);

  for (const field in result) {
    let data = result[field];

    if (
      data === null ||
      (field === 'active' && !(su && result.present === 1)) ||
      (!su &&
        [
          'approved',
          'addNewsfeedItem',
          'sendEmail',
          'sendDeclineEmail',
        ].includes(field))
    ) {
      delete result[field];
    } else if (
      [
        'active',
        'addNewsfeedItem',
        'sendEmail',
        'sendDeclineEmail',
        'present',
      ].includes(field)
    ) {
      result[field] = data ? 1 : 0;
    } else if (field === 'startDate') {
      result.startMonth = data.month;
      result.startYear = data.year;
    } else if (field === 'endDate') {
      if (!result.Present) {
        result.endMonth = data.month;
        result.endYear = data.year;
      }
    } else if (field === 'firmId' && data.__isNew__) {
      result.firmId = -2;
      result.firmOther = data.label;
    } else if (isArray(data)) {
      result[field] = data.map(item => item.value);
    } else if (typeof data === 'object') {
      result[field] = data.value;
    }
  }

  delete result.startDate;
  delete result.endDate;

  return result;
};

export const processOptions = (options, role) => {
  const result = clone(options);

  const { OwnGroups, MainSubgroupTitle } = role.attrs;

  if (OwnGroups) {
    if (MainSubgroupTitle) {
      result.groupId = result.groupId.filter(
        group => Number(group.attrs.roleId) === Number(role.value)
      ).map(group => ({
        ...group,
        group: group.attrs.ProductGroup ? 'Product' : MainSubgroupTitle,
      }));
    } else {
      result.groupId = result.groupId.filter(
        group => Number(group.attrs.roleId) === Number(role.value)
      );
    }
  } else {
    result.groupId = result.groupId.filter(group => !group.attrs.roleId);
  }

  return result;
};
